import Alpine from "alpinejs";

import "./Includes/Js/Directive/InView";

import "../../Atoms/Logo/Logo";
import Button from "../../Atoms/Button/Button";
import InputSlider from "../../Atoms/InputSlider/InputSlider";

import "../../Molecule/Slider/Slider";
import "../../Molecule/Image/Image";

import Logo from "../../Atoms/Logo/Logo";
import ButtonPlay from "../../Atoms/ButtonPlay/ButtonPlay";
import MetaNav from "../../Molecule/Navigation/Meta";

import Section from "../../Molecule/Section/Section";
import MainNav from "../../Molecule/Navigation/Main";
import MobileMenu from "../../Molecule/Navigation/MobileMenu";
import Teasers from "../../Molecule/Teasers/Teasers";
import PageIntro from "../../Molecule/PageIntro/PageIntro";
import CorporateNewsSlider from "../../Molecule/CorporateNewsSlider/CorporateNewsSlider";
import TeasersPaginated from "../../Molecule/Teasers/TeasersPaginated";
import NewsFilter from "../../Molecule/Teasers/NewsFilter";
import Header from "../../Organism/Header/Header";
import Quote from "../../Molecule/Quote/Quote";
import ReturnOfInvestment from "../../Molecule/ReturnOfInvestment/ReturnOfInvestment";
import LinksList from "../../Molecule/LinksList/LinksList";
import PortfolioModule from "../../Molecule/PortfolioModule/PortfolioModule";
import PodcastSlider from "../../Molecule/PodcastSlider/PodcastSlider";
import Explore from "../../Molecule/Explore/Explore";
import Downloads from "../../Molecule/Downloads/Downloads";
import Authentication from "../../Molecule/Authentication/Authentication";
import SocialWall from "../../Molecule/SocialWall/SocialWall";
import ProductsWidget from "../../Molecule/Products/Widget/Widget";
import LoadProductDocuments from "../../Organism/Product/LoadProductDocuments";
import ProductVariants from "../../Molecule/Products/ProductVariants/ProductVariants";
import ProductsDropdown from "../../Molecule/Products/ProductsDropdown/ProductsDropdown";

import { mp3Player } from "../../Molecule/PodcastSlider/Mp3Player";
import { search } from "../../Molecule/Search/Search";
import { productSearch } from "../../Molecule/ProductSearch/ProductSearch";
import { tabs } from "../../Molecule/Tabs/Tabs";
import { chartBar } from "../../Molecule/Products/ChartProgressbar/ChartProgressbar.js";
import { handleScroll } from "../../Organism/HeaderLite/HeaderLite";

import {
  performanceChartFilters,
  performanceChart,
} from "../../Molecule/Products/ProductPerformanceChart/Js/index";
import { productRiskChart } from "../../Molecule/Products/ProductRiskChart/ProductRiskChart";
import Form from "DistributionPackages/Common/Bellevue.Form/Resources/Private/Assets/Form";
import NewsTicker from "DistributionPackages/Common/Bellevue.Ticker/Resources/Private/Assets/Ticker";
import HoldingsOverview from "DistributionPackages/Common/Bellevue.Holdings/Resources/Private/Assets/Holdings";
import TransactionsTable from "DistributionPackages/Common/Bellevue.Transactions/Resources/Private/Assets/Main";
import floatingContactBox from "../../Molecule/FloatingContactBox/FloatingContactBox";
import ProductsTable from "../../Molecule/Products/ProductsTable/ProductsTable";

import AnchorScroll from "./Includes/Js/AnchorScroll";

Alpine.data("logo", Logo);
Alpine.data("pageIntro", PageIntro);
Alpine.data("metaNav", MetaNav);
Alpine.data("mainNav", MainNav);
Alpine.data("mobileMenu", MobileMenu);
Alpine.data("inputslider", InputSlider);
Alpine.data("teasers", Teasers);
Alpine.data("teasersPaginated", TeasersPaginated);
Alpine.data("header", Header);
Alpine.data("button", Button);
Alpine.data("buttonPlay", ButtonPlay);
Alpine.data("tabs", tabs);
Alpine.data("chartBar", chartBar);
Alpine.data("riskChart", productRiskChart);
Alpine.data("performanceChart", performanceChart);
Alpine.data("performanceChartFilters", performanceChartFilters);
Alpine.data("quote", Quote);
Alpine.data("returnofinvestment", ReturnOfInvestment);
Alpine.data("form", Form);
Alpine.data("newsTicker", NewsTicker);
Alpine.data("linksList", LinksList);
Alpine.data("portfolioModule", PortfolioModule);
Alpine.data("podcastSlider", PodcastSlider);
Alpine.data("mp3Player", mp3Player);
Alpine.data("section", Section);
Alpine.data("explore", Explore);
Alpine.data("downloads", Downloads);
Alpine.data("authentication", Authentication);
Alpine.data("newsFilter", NewsFilter);
Alpine.data("floatingContactBox", floatingContactBox);
Alpine.data("search", search);
Alpine.data("productSearch", productSearch);
Alpine.data("socialWall", SocialWall);
Alpine.data("productsWidget", ProductsWidget);
Alpine.data("holdingsOverview", HoldingsOverview);
Alpine.data("transactionsTable", TransactionsTable);
Alpine.data("loadProductDocuments", LoadProductDocuments);
Alpine.data("productsTable", ProductsTable);
Alpine.data("handleScroll", handleScroll);
Alpine.data("productsDropdown", ProductsDropdown);
Alpine.data("productVariants", ProductVariants);

if (!window.Alpine) {
  window.Alpine = Alpine;
  Alpine.start();
}

AnchorScroll().init();
CorporateNewsSlider().init();
